<template>
  <div class="container" @touchstart="touchstart()" @touchmove="touchmove()" @touchend="touchend()">
    <div class="mainContainer firstShow" v-if="firstShow" @click="clickPage">
      <img class="pngLine pngLine1" src="../assets/three_img/p1_line.png"/>
      <img class="pngImg pngImg1" src="../assets/three_img/p1_text.png"/>
      <img class="pngTop" src="../assets/three_img/p1_top.png"/>
      <img class="pngBottom" src="../assets/three_img/p2_bottom.png"/>
    </div>
    <div class="mainContainer secondShow" v-if="secondShow" @click="clickPage">
      <img class="pngLine pngLine2" src="../assets/three_img/p2_line.png"/>
      <img class="pngImg" src="../assets/three_img/p2_text.png"/>
      <img class="pngTop" src="../assets/three_img/p2_top.png"/>
      <img class="pngBottom" src="../assets/three_img/p2_bottom.png"/>
    </div>
    <div class="mainContainer thirdShow" v-if="thirdShow" @click="clickPage">
      <img class="pngLine pngLine3" src="../assets/three_img/p3_line.png"/>
      <img class="pngImg" src="../assets/three_img/p3_text.png"/>
      <img class="pngTop pngTop3" src="../assets/three_img/p3_top.png"/>
      <img class="pngBottom" src="../assets/three_img/p2_bottom.png"/>
      <div id="gaokao"></div>
      <img class="pointGaokao" src="../assets/three_img/point_to_gaokao.png"/>
      <div class="clickDraw">点击绘制</div>
    </div>
    <img class="leftLine" src="../assets/three_line.png"/>
  </div>
</template>
<script>
export default {
  name: 'threePage',
  data () {
    return {
      firstShow: true,
      secondShow: false,
      thirdShow: false,
      clickDrawShow: false,
      startY : 0,
      touching: false,
    }
  },
  mounted () {
    setTimeout(()=>{
      this.firstShow=false
      this.secondShow = true;
    }, 5000)
    setTimeout(()=>{
      this.secondShow = false;
      this.thirdShow = true;
    }, 8000)
  },
  methods:{
    gotoGaokao () {
      this.$router.replace({path:'/four'});
    },
    clickPage () {
      if(this.firstShow){
        setTimeout(()=>{
          this.firstShow=false;
          this.secondShow=true;
        }, 500)
      } else if(this.secondShow){
        setTimeout(()=>{
          this.secondShow=false;
          this.thirdShow=true;
        }, 500)
      } else{
        this.gotoGaokao()
      }
    },
    touchstart(e) {
      e = e || event
      if(!this.touching){
        this.startY = e.touches[0].pageY
        this.touching = true
      }
    },
    touchmove(e) {
      e = e || event
      e.preventDefault()
    },
    touchend (e) {
      e = e || event
      if(this.touching){
        this.touching = false
        let endY = e.changedTouches[0].pageY
        if(endY < this.startY){
          if(this.firstShow){
            this.firstShow=false;
            this.secondShow=true;
          } else if(this.secondShow){
            this.secondShow=false;
            this.thirdShow=true;
          } else{
            this.gotoGaokao()
          }
        }
      }
    },
  }
}
</script>
<style scoped>
.container{
  width: 7.5rem;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.mainContainer{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.firstShow{
  background-color: #fef8f1;
}
.secondShow{
  background-color: #fef8f1;
}
.thirdShow{
  background-color: #fef8f1;
}
.leftLine{
  width: 0.62rem;
  height: 1.33rem;
  position: absolute;
  left: 0;
  bottom: 1.25rem;
}
.mainContainer .pngImg{
  width: 7.5rem;
  height: 13.34rem;
  animation: pointShow 1s 1s;
  animation-fill-mode:forwards;
  opacity: 0;
  margin: 0 auto;
  display: block;
}
.mainContainer .pngImg1{
  animation: pointShow 1s 2s;
  animation-fill-mode:forwards;
}
.mainContainer .pngLine{
  position: absolute;
  left: 50%;
}
.mainContainer .pngLine1{
  width: 5.43rem;
  height: 2.86rem;
  top: 6.8rem;
  transform: translateX(-2.86rem);
}
.mainContainer .pngLine2{
  width: 5.73rem;
  height: 3.82rem;
  top: 5.6rem;
  transform: translateX(-3rem);
}
.mainContainer .pngLine3{
  width: 6rem;
  height: 3.9rem;
  top: 5.2rem;
  transform: translateX(-3.15rem);
}
.mainContainer .pngTop{
  width: 5.1rem;
  height: 3.61rem;
  position: absolute;
  top: 0.7rem;
  left: 50%;
  transform: translateX(-2.55rem);
}
.mainContainer .pngTop3{
  width: 4.91rem;
  height: 3.21rem;
}
.mainContainer .pngBottom{
  width: 7.5rem;
  height: 8.48rem;
  position: absolute;
  bottom: 0;
  right: 0;
}
@keyframes pointShow {
  0% {opacity: 0;}
  100% {opacity: 1;}
}
#gaokao{
  position: absolute;
  width: 0.44rem;
  height: 0.44rem;
  border-radius: 50%;
  border: 0.01rem solid #504e4a;
  top: 6.5rem;
  left: 50%;
  transform: translateX(-0.45rem);
  background: #d7594c;
  animation: beBigger 1s 2s infinite alternate;
  animation-fill-mode:forwards;
  opacity: 0;
}
@keyframes beBigger {
  0% {transform: translateX(-0.55rem) scale(0.5);opacity: 1;}
  100% {transform: translateX(-0.55rem) scale(1);opacity: 1;}
}
.pointGaokao{
  width: 0.69rem;
  height: 0.78rem;
  position: absolute;
  left: 50%;
  top: 4.7rem;
  transform: translateX(-1.2rem);
  animation: pointShow 1s 2s;
  animation-fill-mode:forwards;
  opacity: 0;
}
.clickDraw{
  font-size: 0.2rem;
  position: absolute;
  left: 50%;
  top: 4.9rem;
  transform: translateX(-0.4rem);
  animation: clickShow 1s 2s infinite alternate;
  animation-fill-mode:forwards;
  opacity: 0;
  font-size: 0.3rem;
  color: #d7594c;
}
@keyframes clickShow {
  0% {transform: translateX(-0.4rem); opacity: 0;}
  100% {transform: translateX(-0.4rem); opacity: 1;}
}
</style>

